<template>
  <div>
    <v-dialog
        v-model="dialog"
        max-width="800px"
        @input="onChangeDialog"
    >
      <template v-slot:activator="{ on, attrs }">
        <span v-if="isAdd">
          <v-btn
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              :loading="loading"
          >
            Add
          </v-btn>
        </span>
        <span v-else>
          <v-icon
              v-bind="$attrs"
              v-on="on"
              dark
              :loading="loading"
          >
            mdi-pencil
          </v-icon>
        </span>
      </template>
      <v-container fluid>
        <v-card class="mt-5">
          <v-card-title>
          </v-card-title>

          <v-card-text>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
              <v-file-input
                  class="mt-5"
                  color="primary"
                  type="file"
                  v-model="file"
                  outlined
                  dense
                  @change="onAttachFileChange"
              >
              </v-file-input>
              <TiptapVuetify
                  class="html-editor"
                  v-model="editedItem.title"
                  :extensions="extensions"
              >
              </TiptapVuetify>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="onClose">Cancel</v-btn>
            <v-btn :disabled="!valid" color="blue darken-1" text @click="onSave" :loading="loading">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>
  </div>
</template>


<script>

import {mapActions, mapGetters, mapMutations} from "vuex";
import {mapFields} from "vuex-map-fields";
import {
  TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem,
  Link, Blockquote, HardBreak, HorizontalRule, History, Image
} from "tiptap-vuetify";
import fileFunction from '@/commonFunction/fileFunction'


export default {
  name: 'StoreFileDialog',
  props: {
    itemId: {type: [Number, String], default: null},
    isAdd: {type: Boolean, default: false},
    storeDocItemId: {type: [String, Number], default: null},
    dialogProps: {type: Boolean, default: null},
  },

  computed: {
    dialog: {
      get: function () {
        // console.log('dialogProps', this.dialogProps)
        if (this.dialogProps != null)
          return this.dialogProps
        else
          return this.dialogLocal
      },
      set: function (value) {
        // console.log('dialogProps', value)
        if (this.dialogProps != null)
          this.$emit('update:dialogProps', value)
        else
          this.dialogLocal = value
      }
    },
    file: {
      get: function () {
        if (typeof (this.editedItem.file) === 'string')
          return null
        else
          return this.editedItem.file
      },
      set: function (value) {
        this.editedItem.file = value
      }
    },
    ...mapGetters('StoreFile', []),
    ...mapFields('StoreFile', ['itemList', 'editedItem', 'loading', 'searchTermFile']),
  },

  components: {
    TiptapVuetify,
  },

  methods: {
    ...mapActions('StoreFile', ['fetchItem', 'fetchAddItem', 'fetchSaveItemField', 'fetchUploadFile']),
    ...mapMutations('StoreFile', ['updateEditedItem']),
    async onChangeDialog(event) {
      if (event === true && this.itemId !== null)
        this.fetchItem(this.itemId)
      else
        this.updateEditedItem({'id': null})
    },
    onClose() {
      this.dialog = false
    },
    async onSave() {
      console.log('onSave', this.itemId, this.file, this.editedItem, this.storeDocItemId)
      let fields_dict = {
        title: this.editedItem.title,
        store_doc: this.storeDocItemId,
        source_type: 'Manual',
      }
      console.log(this.editedItem.hasOwnProperty('file'), this.editedItem.file !== null, typeof this.editedItem.file !== 'string')
      if (this.editedItem.hasOwnProperty('file') && this.editedItem.file !== null && typeof this.editedItem.file !== 'string') {
        const file = {
          type: 'file',
          file_name: this.editedItem.file.name,
          file_base64: await fileFunction.getBase64(this.editedItem.file)
        }
        fields_dict['file'] = file
      }
      this.fetchSaveItemField(
          {
            itemId: this.itemId,
            fields_dict: fields_dict,
          })
      this.dialog = false
      this.loading = false
    }
    ,
    onAttachFileChange() {
      console.log('onAttachFileChange', this.editedItem)
      if (!this.editedItem.title && this.editedItem.file != null) {
        this.editedItem.title = this.editedItem.file.name
      }
    }
    ,
  },

  mounted() {
    // this.editedItem = {...this.value}
    // if (this.itemId !== null) {
    //   this.fetchItem(this.itemId)
    // }
  }
  ,

  data() {
    return {
      dialogLocal: false,
      valid: true,
      titleRules: [v => !!v || 'Title is required', v => (v && v.length <= 100) || 'Title must be less than 100 characters',],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3]
          }
        }],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak
      ],
    }
  }
  ,
}

</script>


<style scoped lang="scss">
</style>